<template>
  <div>
   <h1>Welcome to Oscar Night</h1>
  </div>
</template>

<script>
export default {
  name: 'Home'
};
</script>
